import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import Link from '../../atoms/Link/Link';

import { useTranslation } from '@/src/i18n';

const navigationList = [
  {
    title: 'legal_notice_entitled',
    url: '/mentions-legales',
  },
  {
    title: 'personal_data_entitled',
    url: '/donnees-personnelles',
  },
  {
    title: 'referencing_charter_entitled',
    url: '/charte-de-referencement',
  },
];

const RgpdNavigationResponsive = () => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = React.useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  const { asPath } = useRouter();

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className="legal__button-nav killondesk"
      >
        {t('navigation')}&nbsp;
        <img src="/static/images/bottom-arrow.svg" alt="illupadlock" />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="legal__nav"
      >
        {navigationList.map(item => (
          <MenuItem key={item.url} onClick={handleClose}>
            <Link href={item.url} passHref legacyBehavior>
              <a
                title={`${t(item.title)}${
                  item.url === asPath ? ` - ${t('page-active')}` : ''
                }`}
                aria-current={item.url === asPath && 'page'}
              >
                {t(item.title)}
              </a>
            </Link>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const RgpdNavigationMain = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { asPath } = useRouter();

  return (
    <ol className="legal__nav killonmobile">
      {navigationList.map(item => (
        <li
          key={item.url}
          className={clsx({
            active: router?.pathname === item.url,
          })}
        >
          <Link href={item.url} passHref legacyBehavior>
            <a
              title={`${t(item.title)}${
                item.url === asPath ? ` - ${t('page-active')}` : ''
              }`}
              aria-current={item.url === asPath && 'page'}
            >
              {t(item.title)}
            </a>
          </Link>
        </li>
      ))}
    </ol>
  );
};

const RgpdNavigation = () => (
  <div className="legal__sidebar">
    <RgpdNavigationMain />
    <RgpdNavigationResponsive />
  </div>
);

export default RgpdNavigation;
